import { from, ApolloClient, InMemoryCache } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
const createApolloClient = () => new ApolloClient({
  link: from([
    createUploadLink({
      uri: `${process.env.GATSBY_DRUPAL_URL}/graphql`,
      credentials: 'include',
    }),
  ]),
  cache: new InMemoryCache(),
  // Evitar que el caché crezca indefinidamente con resultados de búsquedas
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
    },
    query: {
      fetchPolicy: 'network-only',
    },
  },
})

// En SSR (servidor) creamos una instancia nueva por cada ciclo
// En browser reutilizamos el singleton para mantener UX fluida
let clientInstance = null

const client = typeof window === 'undefined'
  ? createApolloClient()    // Servidor: instancia fresca sin caché acumulado
  : (clientInstance || (clientInstance = createApolloClient())) // Browser: singleton

export default client
